module.exports = __webpack_public_path__ + "static/media/arrow_icon.b8257f88.svg";